<template>
  <div class="full-screen-background">
    <v-container class="pa-4 fill-height">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <div class="text-center mb-4">
            <h2>{{ t('changeCreds.greeting1') }}</h2>
            <h2>{{ t('changeCreds.greeting2') }}</h2>
          </div>

          <v-form ref="form">
            <!-- Novo e-mail (opcional) -->
            <v-text-field
              v-model="newEmail"
              :label="t('changeCreds.newEmail.label')"
              :hint="t('changeCreds.newEmail.hint')"
              persistent-hint
              :rules="[v => !v || /.+@.+\..+/.test(v) || t('changeCreds.validation.emailInvalid')]"
            />

            <v-divider class="my-6" />

            <!-- Fluxo de troca de senha -->
            <v-text-field
              v-model="currentPassword"
              :type="showPasswords ? 'text' : 'password'"
              :label="t('changeCreds.currentPassword.label')"
              :append-inner-icon="showPasswords ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append-inner="showPasswords = !showPasswords"
            />
            <v-text-field
              v-model="newPassword"
              :type="showPasswords ? 'text' : 'password'"
              :label="t('changeCreds.newPassword.label')"
              :append-inner-icon="showPasswords ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append-inner="showPasswords = !showPasswords"
            />
            <v-text-field
              v-model="confirmPassword"
              :type="showPasswords ? 'text' : 'password'"
              :label="t('changeCreds.confirmPassword.label')"
              :append-inner-icon="showPasswords ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append-inner="showPasswords = !showPasswords"
            />

            <div class="text-center mt-4">
              <v-btn color="#5c3e62" @click="onSubmit">
                {{ t('changeCreds.updateButton') }}
              </v-btn>
            </div>

            <v-alert v-if="message" :type="messageType" class="mt-4" dense>
              {{ message }}
            </v-alert>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { auth } from '../auth'
import {
  changePassword,
  requestEmailChange
} from '@/services/api'

const { t } = useI18n()
const router = useRouter()

const newEmail = ref('')
const currentPassword = ref('')
const newPassword = ref('')
const confirmPassword = ref('')
const showPasswords = ref(false)

const message = ref('')
const messageType = ref('')

async function onSubmit() {
  message.value = ''
  // nada preenchido
  if (
    !newEmail.value.trim() &&
    !currentPassword.value.trim() &&
    !newPassword.value.trim() &&
    !confirmPassword.value.trim()
  ) {
    message.value = t('changeCreds.error.noChange')
    messageType.value = 'error'
    return
  }

  const token = auth.token

  // if only email
  if (newEmail.value.trim() && !currentPassword.value) {
    try {
      await requestEmailChange(token, newEmail.value)
      message.value = t('changeCreds.success.emailConfirmationSent')
      messageType.value = 'success'
      newEmail.value = ''
    } catch (err) {
      message.value = err.message
      messageType.value = 'error'
    }
    return
  }

  // fluxo de senha
  if (!currentPassword.value || !newPassword.value || !confirmPassword.value) {
    message.value = t('changeCreds.error.fillPassword')
    messageType.value = 'error'
    return
  }
  if (newPassword.value !== confirmPassword.value) {
    message.value = t('changeCreds.error.passwordMismatch')
    messageType.value = 'error'
    return
  }
  if (newPassword.value.length < 8) {
    message.value = t('changeCreds.error.passwordLength')
    messageType.value = 'error'
    return
  }

  try {
    await changePassword(token, currentPassword.value, newPassword.value)
    message.value = t('changeCreds.success.passwordUpdated')
    messageType.value = 'success'
    setTimeout(() => router.push({ name: 'Home' }), 1500)
  } catch (err) {
    message.value = err.message
    messageType.value = 'error'
  } finally {
    currentPassword.value = ''
    newPassword.value = ''
    confirmPassword.value = ''
  }
}
</script>

<style scoped>
.full-screen-background {
  background-image: url('@/assets/background/fundotrocasenha.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  position: relative;
}
.full-screen-background::before {
  content: '';
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.3);
}
</style>
